module.exports = function addScrollEventListener(element, handler) {
  var scrollTicking = false;

  element.addEventListener('scroll', function (e) {
    if (scrollTicking) return;

    window.requestAnimationFrame(function () {
      handler(e);
      scrollTicking = false;
    });
    scrollTicking = true;
  });
};



//////////////////
// WEBPACK FOOTER
// ./src/js/helpers/addscrolleventlistener.js
// module id = 18
// module chunks = 0